import React, { useState } from 'react';
import { createInteraction } from '../../lib/api';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { toast } from 'sonner';

export const NoteDialog = ({ open, onOpenChange, dossierId, onAdded }) => {
    const [noteType, setNoteType] = useState('note');
    const [content, setContent] = useState('');

    const handleAdd = async () => {
        if (!content.trim()) return;
        try {
            await createInteraction({ dossier_id: dossierId, type_interaction: noteType, contenu: content });
            toast.success('Note ajoutée');
            setContent('');
            onOpenChange(false);
            onAdded && onAdded();
        } catch {
            toast.error("Erreur lors de l'ajout");
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Ajouter une note</DialogTitle>
                </DialogHeader>
                <div className="space-y-4">
                    <div>
                        <Label className="field-label">Type</Label>
                        <Select value={noteType} onValueChange={setNoteType}>
                            <SelectTrigger className="h-10 rounded-sm mt-1"><SelectValue /></SelectTrigger>
                            <SelectContent>
                                <SelectItem value="note">Note interne</SelectItem>
                                <SelectItem value="appel">Appel</SelectItem>
                                <SelectItem value="email">Email</SelectItem>
                                <SelectItem value="sms">SMS</SelectItem>
                                <SelectItem value="rdv">Rendez-vous</SelectItem>
                            </SelectContent>
                        </Select>
                    </div>
                    <div>
                        <Label className="field-label">Contenu</Label>
                        <Textarea
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                            rows={4}
                            className="rounded-sm mt-1"
                            placeholder="Écrivez votre note..."
                            data-testid="note-content"
                        />
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
                    <Button onClick={handleAdd} className="bg-[#E85A24] hover:bg-[#CC4D1C] text-white">Ajouter</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
